import { borderRadius } from "../borders";
import { fontSize, fontWeight } from "../typography";

export const MuiDialog = {
  styleOverrides: {
    paper: {
      borderRadius: borderRadius.primary,
      padding: "26px",
    },
  },
};

export const MuiDialogTitle = {
  styleOverrides: {
    root: {
      fontSize: fontSize.large,
      fontWeight: fontWeight.bold,
      textAlign: "center",
    },
  },
};

export const MuiDialogContent = {
  styleOverrides: {
    root: {
      marginTop: "28px",
      marginBottom: "44px",

      // ol: {
      //   listStyle: "decimal !important",
      // },
    },
  },
};

export const MuiDialogActions = {
  styleOverrides: {
    root: {
      justifyContent: "center",
    },
  },
};
